import { useDispatch, useSelector } from "react-redux";
import { agencyApplicationSelector } from "../../../redux/selector/agencyApplicationSelector";
import { currentPendingMainAgentChangeRequests } from "../../../redux/selector/mainAgentChangeRequestSelector";
import { applicationTypeFromLicenceSubType } from "../../../redux/slice/applicationsUtils";
import TopNavigationBar from "../../TopNavigationBar";
import { useEffect, useState } from "react";
import {
  Paragraph,
  Button,
  ErrorMark,
  ErrorWithString
} from "../../../components/RegularComponents";
import { ValidateString } from "../../../app/utils";
import {
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  REQUEST_STATUS,
  ROUTE_PATH
} from "../../../app/constants";
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from "../../../app/errors";
import { push } from "connected-react-router";
import { setCurrentMainAgentChangeRequestDataObject } from "../../../redux/slice/primaryAgencyApplicationSlice";
import { saveBusinessLicenceApplicationData } from "../../../redux/slice/businessLicenceApplicationSlice";

export const MainAgentChangeRequestNewEmail = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const { applicationMode } = props.match.params;
  const { agencyApplication } = useSelector(agencyApplicationSelector) || {};
  const { mainAgentChangeRequest } = useSelector(currentPendingMainAgentChangeRequests);
  const serverSaveRequest = useSelector(
    (state) => state.primaryAgencyApplication.serverRequestStatus
  );
  const licencingSubType = agencyApplication?.licencingSubType;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const mainAgentTypeString =
    applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
      ? "Principal Broker"
      : "Compliance Officer";
  // const localHost = `${window.location.protocol}//${window.location.host}/#/`;
  // const mainAgentNewApplicationLink = `${localHost}${
  //   applicationType === APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
  //     ? "principal-broker"
  //     : "compliance-officer"
  // }/privacy-notice`;

  const dispatch = useDispatch();

  const [newAgentEmailAddress, setNewAgentEmailAddress] = useState();
  const [showValidationError, setShowValidationError] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false);
  // const [copyLinkToClipboardStatus, setCopyLinkToClipboardStatus] = useState();
  const [emailValidationError, setEmailValidationError] = useState(VALIDATION_ERROR.NO_ERROR);

  useEffect(() => {
    setNewAgentEmailAddress(mainAgentChangeRequest?.changeRequestData?.nextMainAgentEmail);
  }, [mainAgentChangeRequest]);

  const validateEmailAddress = () => {
    const ret = ValidateString(newAgentEmailAddress, VALIDATION_TYPE.EMAIL);
    setEmailValidationError(ret);
    return ret === VALIDATION_ERROR.NO_ERROR;
  };

  const isEmailValid = () => {
    if (showValidationError) {
      return emailValidationError === VALIDATION_ERROR.NO_ERROR;
    }

    return true;
  };

  const handleSave = () => {
    setShowValidationError(false);
    const isValid = validateEmailAddress();

    if (isValid) {
      const changeRequestData = mainAgentChangeRequest?.changeRequestData ?? {};
      // push the date, reason and confirmation
      dispatch(
        setCurrentMainAgentChangeRequestDataObject({
          ...changeRequestData,
          nextMainAgentEmail: newAgentEmailAddress
        })
      );

      return true;
    }

    setShowValidationError(true);

    return false;
  };

  const handleSaveAndNext = () => {
    if (handleSave()) {
      //Main app + parent app has to be updated
      dispatch(
        saveBusinessLicenceApplicationData(
          applicationTypeFromLicenceSubType(licencingSubType),
          applicationMode
        )
      )
        .then(() => {
          dispatch(push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_MAIN_AGENT_CHANGE_REQUEST_REVIEW}`));
        })
        .catch((err) => {
          setApplicationSaveError(true);
        });
    }
  };

  const handleSaveAndClose = () => {
    if (handleSave()) {
      onEditSave();
    }
  };

  /*
  function canCopyToClipboard() {
    return navigator.clipboard !== null || navigator.clipboard !== undefined;
  }

  function copyTextToClipboard(text) {
    setCopyLinkToClipboardStatus("in-progress");
    navigator.clipboard.writeText(text).then(
      () => {
        setTimeout(() => {
          setCopyLinkToClipboardStatus("complete");
        }, 1000);
      },
      () => {
        setCopyLinkToClipboardStatus("failure");
      }
    );
  }
  */

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          <TopNavigationBar
            {...props}
            applicationType={applicationType}
            applicationMode={applicationMode}
          />
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <h1>{`New ${mainAgentTypeString}`}</h1>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 col-lg-8">
              <Paragraph
                id="new-agent-email-info-1"
                text={[
                  `Please provide an email address for the new ${mainAgentTypeString}. When the change request is approved, they will be sent a link to apply to become the new ${mainAgentTypeString}. If their email is currently unavailable, you can provide your own email address and receive the link.`
                ]}
              />
            </div>
          </div>

          <div className="row topMarginMedium">
            <div className="col-xs-12 col-lg-8">
              <fieldset
                className={"ns-fieldset" + (!isEmailValid() ? " ns-fieldset-message-error" : "")}
              >
                {!isEmailValid() && (
                  <span
                    id={"change-request-reason-input-error"}
                    className="ns-error-message field-validation-error"
                  >
                    {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_EMAIL_INVALID)}
                  </span>
                )}
                <input
                  className={"fw-20" + (isEmailValid() ? " ns-input" : " ns-input--error")}
                  type="text"
                  autoComplete="email"
                  id={"new-agent-email-input"}
                  name={"new-agent-email-input"}
                  onInput={(e) => {
                    setEmailValidationError(VALIDATION_ERROR.NO_ERROR);
                    setNewAgentEmailAddress(e.target.value);
                  }}
                  value={newAgentEmailAddress}
                />
              </fieldset>
            </div>
          </div>

          {/*
          <div className="row bottomMarginLarge">
            <div className={"col-lg-12"}>
              <a  
                rel="noreferrer"
                href={mainAgentNewApplicationLink}
                style={{textDecoration: "underline", marginRight: '25px'}}
                target="_blank"
              >
                  {`New ${mainAgentTypeString} Application`}
              </a>
              {canCopyToClipboard() &&
              <> 
                <Button 
                  id="copy-pb-flow-link-button"
                  buttonType={"regular_primary"}
                  text="Copy Link"
                  showSpinner={copyLinkToClipboardStatus === "in-progress"}
                  onClick={() => copyTextToClipboard(mainAgentNewApplicationLink)} />
                </>
              }
            </div>
          </div>
          */}

          <div className="row">
            <div className={"col-lg-4"}>
              <Button
                id="change-reason-save-button"
                style={{ margin: "0 10px 10px 0" }}
                buttonType={"regular_primary"}
                text={!isModal ? "Save and Continue" : "Save and close"}
                onClick={!isModal ? handleSaveAndNext : handleSaveAndClose}
                showSpinner={
                  !applicationSaveError && serverSaveRequest === REQUEST_STATUS.IN_PROGRESS
                }
                disabled={serverSaveRequest === REQUEST_STATUS.IN_PROGRESS}
              />
              {showValidationError && ErrorMark()}
              {showValidationError && (
                <div className="ns-error-message">
                  <span className="ns-visually-hidden">Error:</span>
                  {ERROR_STRING.CHECK_FIELDS}
                </div>
              )}
              {applicationSaveError && ErrorMark()}
              {applicationSaveError && (
                <div className="ns-error-message help-block topMarginNormal">
                  <span className="ns-visually-hidden">Error:</span>
                  {ERROR_STRING.APPLICATION_SAVE_ERROR}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
